<template>
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template v-slot:body>
            <div class="search-wrap" >
                <div class="row">
                <div class="col-md-3">
                    <div class="mb-3">
                        <ElLabel name="영업기회ID">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.sales_id" @inputKeyupEnter="getSalesList"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <ElLabel name="EndUser">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.end_user_cmp_nm" @inputKeyupEnter="getSalesList"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <ElLabel name="매출처">
                            <template #end="{id}">
                                <ElInput :id="id" v-model="state.searchParams.sales_cmp_nm" @inputKeyupEnter="getSalesList"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>                     
                </div>
            </div>


            <div class="search-detail-wrap"></div>

            <div class="text-end py-2">
                <ElButton type="search" @buttonClick="getSalesList()">검색</ElButton>
            </div>

            <div class="table-responsive table-list">
                <DataTable  
                    v-model:selection="state.selectedRow" 
                    :value="state.gridRowData"   
                    selectionMode="single"
                    dataKey="index"
                    paginator 
                    :rows="20" 
                    :rowsPerPageOptions="[10, 20, 50, 100,200]" 
                    @row-dblclick= "dblSelectMng"
                    >
                    <template #empty>
                        <div class="center">데이터가 존재하지 않습니다.</div>
                    </template>
                    <Column v-for="sales of state.gridColumn" :key="sales.mng_seq" :field="sales.field" :header="sales.headerName" sortable style="min-width: 100px"></Column>
                </DataTable>
            </div>
        </template>
    </BaseModal>


</template>

<script setup>
import { reactive,ref,onBeforeMount } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import BaseModal from './BaseModal.vue';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { salesOptyList } from '@/api/sales';
const emits = defineEmits(['return'])

const baseModalRef = ref()

const state = reactive({

    gridColumn :[
        { headerName: 'ID' , field: "sales_id",checkboxSelection: true},
        { headerName: 'End User' ,field: "end_user_cmp_nm",  cellDataType: 'text'},
        { headerName: '매출처' ,field: "sales_cmp_nm", cellDataType: 'text'}
    ],    
    gridRowData :[],
    selectedRow :[],
      searchParams: {
        sales_id:'',
        end_user_cmp_nm : '',
        sales_cmp_nm : ''
      }
})

const childProps = ref({
    modalId : 'sales',
    modalNm : '영업기회 조회',
    size : 'xl',
    btnList : [
        {name : '선택' , classNm:'modelFooterConfirm',function : selectMng}
    ]
})

function openModal(){
    baseModalRef.value.openModal()
}

function closeModal(){
    baseModalRef.value.closeModal()
}
//영업기회 조회
async function getSalesList(){
    try {
        setIsLoading(true)
        const res = await salesOptyList(state.searchParams)
        state.gridRowData = [...res.rtn].map((item,index)=>{
            item.index = index
            return item
        })
    } catch (err) {
        console.error(err)
    } finally {
        setIsLoading(false)
    }
}

function dblSelectMng(row){
    let DblClickSales = row.data
    if(DblClickSales != null && closeModal != undefined && closeModal != ''){
        emits('return',DblClickSales)
        closeModal()
    }else{
        alert('선택된 영업ID가 없습니다.')
    }
}

function selectMng(){
    let SelectSales = state.selectedRow
    if(SelectSales != null && closeModal != undefined && closeModal != ''){
        emits('return',SelectSales)
        closeModal()
    }else{
        alert('선택된 영업ID가 없습니다.')
    }
}



defineExpose({
    openModal
})
</script>